import { getCurrentCulture } from 'owa-localize';
import { isFeatureEnabled } from 'owa-feature-flags';
import type ISkypeApi from '../store/schema/ISkypeApi';
import getShellClientData from './getShellClientData';

interface SkypeInterface {
    initialize: (options: any, callback: (api: ISkypeApi) => void) => void;
}

declare var Skype: SkypeInterface;

const SKYPE_BOOTSTRAP_SCRIPT_SRC =
    'https://shellprod.msocdn.com/swx/shared/v/1.2.29/SkypeBootstrap.min.js';

const IS_SDF_OR_MSFT = isFeatureEnabled('ring-dogfood') || isFeatureEnabled('ring-microsoft');
const UCWA_API_KEY = IS_SDF_OR_MSFT
    ? '2a9f196e-2926-4f83-80a2-543bfbd2f75a'
    : 'b32c0389-1143-4a42-b15f-7b860f9eafbb';
const UCWA_HOST_PROPERTY = 'Exchange';
let getSkypeApiPromise: Promise<ISkypeApi>;
let getSkypePromise: Promise<SkypeInterface>;

function getSkype(): Promise<SkypeInterface> {
    if (!getSkypePromise) {
        getSkypePromise = new Promise(resolve => {
            const skypeDownloadScript = document.createElement('script');
            skypeDownloadScript.type = 'text/javascript';
            skypeDownloadScript.src = SKYPE_BOOTSTRAP_SCRIPT_SRC;
            skypeDownloadScript.onload = () => resolve(Skype);
            document.head.appendChild(skypeDownloadScript);
        });
    }
    return getSkypePromise;
}

export default function getSkypeApi(reinit?: boolean): Promise<ISkypeApi> {
    if (!getSkypeApiPromise || reinit) {
        getSkypeApiPromise = new Promise<ISkypeApi>(async resolve => {
            const clientData = getShellClientData();
            const skype = await getSkype();

            skype.initialize(
                {
                    apiKey: UCWA_API_KEY,
                    locale: getCurrentCulture(),
                    resigninAllowed: true,
                    disableTelemetry: true,
                    correlationIds: {
                        upn: clientData.UPN,
                        userAppId: 1,
                        hostProperty: UCWA_HOST_PROPERTY,
                        userId: clientData.UID,
                        tenantId: clientData.TID,
                        sessionId: clientData.SHSID,
                    },
                    isDogfoodExperience: IS_SDF_OR_MSFT,
                    isSkypeForBusiness: true,
                    isSkypeHostedOnPremises: false,
                },
                api => {
                    resolve(api);
                }
            );
        });
    }

    return getSkypeApiPromise;
}
